export default {
    pleaseChoose: "Please Select"
}